import {BifrostBackendNestApi} from "../gateways/BifrostBackendApi";
import {store} from "../store";
import appConfig from "../appconfig";

export default {
	async listByClientTraceId() {
		const response = await BifrostBackendNestApi.get("/limited-discount-assignment", {
			headers: {
				Authorizationidp: store.getters.applicationUserIdpToken
			},
			params: {
				clientTraceId: appConfig.clientTraceId()
			}
		});

		return response.data;
	}
};
